<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-9">
<h1>10</h1>
<p>Still nothing from reclusive Sammy, so I journey south of the city, over Shaw’s Bridge, then over Minnoburn bridge to Rix and McBeath Joinnery Works.</p>
<p>When I walk through an open gateway the sound of saws and planers and other woodworking machines comes from one workshop, the sound of hammering from another. To the right is the office. I go in through an open door and knock on another which is closed.</p>
<p>“Come in.”</p>
<p>In I go.</p>
<p>“Stanley Eigerman, I phoned earlier.”</p>
<p>“Stanley Ross.” We shake hands. “What can one Stanley do for another? Have a seat.”</p>
<p>“Stanley, you were around when Steven Ford worked here. I’d like you to tell me about him.”</p>
<p>“That was years ago. I own the firm now. If Steve was alive he’d be my partner.”</p>
<p>“When was the last time you saw Steven?”</p>
<p>“That would be the day Steve was sent to the building site to put the winders on flights of stairs we made here in the workshop. I never saw him after that.”</p>
<p>“You were friends.”</p>
<p>“Mates, used to go out together regularly. To the pictures, football matches, and dances.”</p>
<p>“Did he ever talk about his father?”</p>
<p>“Often. Told me he was sure that his father had been murdered by the other men who were with him the day he died, and he was going to prove it even if it killed him. Seems it did.”</p>
<p>“Did he ever tell you what he’d found out?”</p>
<p>“He said he knew the names of the men who were with his father that day. He didn’t say who they were.”</p>
<p>“He had a girlfriend, ever meet her?”</p>
<p>“Oh yes, We went to dance lessons. That’s where Steve met her; and I met my wife. He was smitten with this good lookin’ red head, Jean McBride, that was her name. Came from the country. Very serious about her.”</p>
<p>“Know what happened to Jean after Steve was taken?”</p>
<p>“We tried to keep in touch, but she didn’t answer our calls.”</p>
<p>“You have her phone number?”</p>
<p>“I’m sure we do.”</p>
<p>“When you were at dancing classes, did the four of you have photographs taken?”</p>
<p>“Come to think of it, we have a photo of the four of us.”</p>
<p>“I’d like to see it.”</p>
<p>“No problem.” Stanley gets up. I follow him. He lives in a rather grand house back of the workshop. He tells me the house belonged to a mill owner, who whiskied himself into poverty.</p>
<p>“Anna, are you in or out?” he shouts as we stand in the hall.</p>
<p>“What has you here at this time of day?” comes a voice.</p>
<p>“I’ve brought a visitor. Are you goin’ to show yourself?”</p>
<p>“Male or female?”</p>
<p>“He’s male, so he won’t mind what you look like.”</p>
<p>“He’s not blind, is he?”</p>
<p>“I’ll have him in the front room when you think you’re ready.”</p>
<p>I’m seated when Anna comes in. I get up.</p>
<p>“You’ve brought a gentleman, I see.” She’s a woman with the looks of spring not yet vanished. With love, Stanley presents her to me. Tells her I’m a detective, asking about Steve, and Jean McBride.</p>
<p>“Remember that photo we had of the four of us. Do you happen to know where it is?”</p>
<p>“And you a Stanley, too. Imagine! Now, I won’t have you sittin’ there without a wee cup of tea in your hand. And I suppose you’ll want one too.”</p>
<p>“With scones, and jam and cream,” Stanley says.</p>
<p>“And you on a diet.”</p>
<p>“Aye, but only between meals. Do you know where that photo is?”</p>
<p>“I do. I’ll get it.”</p>
<p>Anna comes back wheeling a trolley laden with scones, butter, jam and whipped cream, I say: “You have the gift of hospitality, it’s appreciated.”</p>
<p>“And what gift have you, Stanley?”</p>
<p>“Helping, when possible.”</p>
<p>“And who will our photo help?”</p>
<p>“Steven Ford’s mother. She wants me to find Steven’s remains.”</p>
<p>“Ach, poor woman. My heart goes out to her. All these years, not knowing.”</p>
<p>“You got to know Jean McBride. Tell me about her.”</p>
<p>“Lovely girl.”</p>
<p>“Just like yourself,” says Stanley.</p>
<p>“I don’t blame Steve for goin’ overboard for her. She told me that what first attracted him was her red hair.”</p>
<p>“And green eyes,” Stanley says.</p>
<p>“You noticed, did you?”</p>
<p>“I did, I did.”</p>
<p>“Was Jean as attracted to Steven as he was to her?”</p>
<p>“I’m sure she was. She said one time ‘He’s honest and he expects everybody to be honest.’ He had this thing about finding out about his father, and because of it we sort of split up after we tried to get him to let it lie, and get on with his own life.”</p>
<p>“For a while I kept in touch with Jean, but after he was taken we lost contact. She worked in the Bank Buildings, but when I tried to see her, they told me she’d left. I was awful sorry about that.”</p>
<p>“Do you happen to know where she lived in the country?”</p>
<p>“I think somewhere along the Seven Mile Straight but I’m not sure where.”</p>
<p>“May I see your photo?”</p>
<p>Anna takes it from an envelope she has on the trolley and hands it to me. I see four young faces standing, looking at the camera. Three smiling, and one serious-faced; Steven. I recognise Stanley and Anna. The other girl, Jean, has an arm around Steven’s shoulders and he an arm about her waist.</p>
<p>They allow me to photograph it to my phone.</p>
<p>Anna asks, “Do you really think you’ll find Steven’s remains? There’s so many that’ll never be found.”</p>
<p>“With God’s help and guidance, I hope so.”</p>
<p>Stanley gives me Jean’s phone number. I give him my card and come away with the feeling that these good people think I’m going to fail.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch014.vue?196f2742